import React, { Component } from 'react';
import moment from 'moment';
import AddEducation from './Add';
import EditEducation from './Edit';
import debounce from 'lodash/debounce';
import svg from '../../../../assets/img/profile.svg';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { listInstitutions, unmountListInstitutions } from '../../../../redux/actions/master/institutions/institutionsAction';
import { listFieldOfStudy, unmountListFieldOfStudy } from '../../../../redux/actions/master/fieldOfStudy/fieldOfStudyAction';
import { masterEducationLevel, unmountMasterEducationLevel } from '../../../../redux/actions/master/educationLevel/educationLevelAction';
import { addEducation, deleteEducation, detailCandidate, unmountDetailCandidate, updateEducation, enableCandidate } from '../../../../redux/actions/candidate/candidateAction';
import { Skeleton, Row, Col, Breadcrumb, PageHeader, Card, Button, Space, Avatar, Typography, Descriptions, Divider, Tooltip, Empty, Modal, Tag, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import Menu from '../Menu';
const { Text } = Typography;
const { confirm } = Modal;
const Icon = ({ type, ...rest }) => {
  const icons = require(`@ant-design/icons`);
  const Component = icons[type];
  return <Component {...rest} />
};
class CandidateDetailEducation extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props)
  
    this.state = {
      dataEducation: null,
      submitLoading: false,
      visibleAdd: false,
      visibleEdit: false,
      startYear: null,
      endYear: null,
      isYear: false,
      current: false,
      metaInstitution: {
        page: 1,
        perpage: 10,
        search: ''
      },
      metaFieldOfStudy: {
        page: 1,
        perpage: 10,
        search: '',
        educationLevelId: ''
      },
      educationLevelId: null,
      isBinawan: false
    }
    this.onSearchInstitution = debounce(this.onSearchInstitution.bind(this), 800)
    this.onSearchFieldOfStudy = debounce(this.onSearchFieldOfStudy.bind(this), 800)
  }
  

  componentDidMount() {
    const { actionGetDetail, match: { params } } = this.props;
    actionGetDetail(params.id)
  }

  showModal = (type, item) => {
    const { actionGetEducation } = this.props;
    actionGetEducation()
    if(type === 'add'){
      return this.setState({ visibleAdd: true })
    }
    if(type === 'edit'){
      this.setState({ 
        visibleEdit: true, 
        dataEducation: item,
        educationLevelId: item.educationLevelId,
        current: item.current,
        isBinawan: item?.name === 'Universitas Binawan' ? true : false
      }, () => {
      })
    }
  }

  onCancel = (type) => {
    const { metaInstitution, metaFieldOfStudy } = this.state;
    if(type === 'add'){
      metaInstitution.page = 1
      metaInstitution.perpage = 10
      metaInstitution.search = ''
      metaFieldOfStudy.page = 1
      metaFieldOfStudy.perpage = 10
      metaFieldOfStudy.search = ''
      metaFieldOfStudy.educationLevelId = ''
      return this.setState({ 
        visibleAdd: false,
        startYear: null,
        endYear: null,
        isYear: false,
        current: false,
        metaInstitution,
        metaFieldOfStudy
      })
    }
    if(type === 'edit'){
      metaInstitution.page = 1
      metaInstitution.perpage = 10
      metaInstitution.search = ''
      metaFieldOfStudy.page = 1
      metaFieldOfStudy.perpage = 10
      metaFieldOfStudy.search = ''
      metaFieldOfStudy.educationLevelId = ''
      return this.setState({ 
        dataEducation: null,
        visibleEdit: false,
        startYear: null,
        endYear: null,
        isYear: false,
        current: false,
        metaInstitution,
        metaFieldOfStudy
      })
    }
  }

  onSearchInstitution = (value) => {
    const { metaInstitution } = this.state;
    const { actionGetInstitution } = this.props;
    metaInstitution.page = 1
    metaInstitution.perpage = 10
    metaInstitution.search = value
    return actionGetInstitution(metaInstitution)
  }

  onFocusInstitution = () => {
    const { metaInstitution } = this.state;
    const { actionGetInstitution } = this.props;
    return actionGetInstitution(metaInstitution)
  }

  onChangeInstitution = (e) => {
    this.setState({ isBinawan: e === 'Universitas Binawan' ? true : false })
  }

  onSearchFieldOfStudy = (value) => {
    const { metaFieldOfStudy, educationLevelId } = this.state;
    const { actionGetFieldOfStudy } = this.props;
    metaFieldOfStudy.page = 1
    metaFieldOfStudy.perpage = 10
    metaFieldOfStudy.search = value
    metaFieldOfStudy.educationLevelId = educationLevelId
    return actionGetFieldOfStudy(metaFieldOfStudy)
  }

  onFocusFieldOfStudy = () => {
    const { metaFieldOfStudy, educationLevelId } = this.state;
    const { actionGetFieldOfStudy } = this.props;
    metaFieldOfStudy.page = 1
    metaFieldOfStudy.perpage = 10
    metaFieldOfStudy.educationLevelId = educationLevelId
    return actionGetFieldOfStudy(metaFieldOfStudy)
  }

  onChangeEducationLevel = (value) => {
    this.setState({
      educationLevelId: value
    })
    this.formRef.current.setFieldsValue({
      fieldOfStudy: null
    })
  }

  onChangeStartYear = (date, dateString) => {
    const { endYear } = this.state
    this.setState({ startYear: dateString })
    if(endYear <= dateString){
      this.setState({ isYear: true })
    }else{
      this.setState({ isYear: false })
    }
  }

  onChangeEndYear = (date, dateString) => {
    const { startYear } = this.state
    this.setState({ endYear: dateString })
    if(dateString <= startYear){
      this.setState({ isYear: true })
    }else{
      this.setState({ isYear: false })
    }
  }

  handleChecked = (e) => {
    this.setState({ current: e.target.checked })
    if(e.target.checked){
      this.setState({ endYear: null })
      this.formRef.current.setFieldsValue({
        endYear: null
      })
    }
  }

  handleDelete = (id) => {
    const { actionDelete, actionGetDetail, match: { params } } = this.props;
    confirm({
      title: 'Remove Data',
      okText: 'Yes',
      cancelText: 'No',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure want to remove this data?',
      onOk() {
        return actionDelete(id, () => {
          message.success('Data deleted successfully')
          return actionGetDetail(params.id)
        }, (err) => message.error(err))
      },
    });
  }

  onSubmitAdd = () => {
    const { current } = this.state;
    const { actionAdd, actionGetDetail, match: { params } } = this.props;
    this.setState({ submitLoading: true })
    this.formRef.current.validateFields().then(values => {
      values.current = current
      values.candidateId = Number(params.id)
      values.startYear = values.startYear ? moment(values.startYear).format('YYYY') : null
      values.endYear = values.endYear ? moment(values.endYear).format('YYYY') : null
      return actionAdd(values, () => {
        return this.setState({ submitLoading: false }, () => {
          return this.setState({ visibleAdd: false }, () => {
            message.success('Data created successfully')
            actionGetDetail(params.id)
          })
        })
      }, (err) => {
        return this.setState({ submitLoading: false }, () => message.error(err))
      })
    })
  }

  onSubmitEdit = () => {
    const { current, dataEducation } = this.state;
    const { actionUpdate, actionGetDetail, match: { params } } = this.props;
    this.setState({ submitLoading: true })
    this.formRef.current.validateFields().then(values => {
      values.id = dataEducation.id
      values.current = current
      values.candidateId = Number(params.id)
      values.startYear = values.startYear ? moment(values.startYear).format('YYYY') : null
      values.endYear = values.endYear ? moment(values.endYear).format('YYYY') : null
      return actionUpdate(values, () => {
        return this.setState({ submitLoading: false }, () => {
          return this.setState({ visibleEdit: false }, () => {
            message.success('Data updated successfully')
            return actionGetDetail(params.id)
          })
        })
      }, (err) => {
        return this.setState({ submitLoading: false }, () => message.error(err))
      })
    })
  }
  
  showConfirmActive = () => {
    const { actionEnable, actionGetDetail ,match: { params } } = this.props;
    confirm({
      title: 'Unable to edit profile due to candidate status is inactive. Do you want to change candidate status to active?',
      icon: <ExclamationCircleOutlined />,
      width: 700,
      onOk() {
        return actionEnable(params.id, () => {
          message.success('Successfully changed to active')
          return actionGetDetail(params.id)
        }, (err) => message.error(err))
      },
      okText: 'Change to Active',
      onCancel() {},
    });
  };

  render() {
    const { visibleAdd, visibleEdit, isBinawan } = this.state;
    const { getDetailCandidate: { loading, data } } = this.props;
    if(loading){
      return <Skeleton avatar />
    }
    return (
      <React.Fragment>
        <Row gutter={[16, 16]}>
          {/* Breadcrumb */}
          <Col span={24}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Icon type={this.props.icon} />
                {
                  this.props.url.split('/')[1] === 'all-candidate' ?
                    ' All Candidates'
                  : this.props.url.split('/')[1] === 'new-candidate' ?
                    ' New Candidates'
                  : this.props.url.split('/')[1] === 'counseling-process' ?
                    ' Counseling Process'
                  : this.props.url.split('/')[1] === 'assigned-candidate' ?
                    ' Assigned Candidates'
                  :
                    ' Candidates'
                }
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link className="link" to={`/${this.props.url.split('/')[1]}`}>
                  {
                    this.props.url.split('/')[1] === 'all-candidate' ?
                      'All Candidates List'
                    : this.props.url.split('/')[1] === 'new-candidate' ?
                      'New Candidates List'
                    : this.props.url.split('/')[1] === 'counseling-process' ?
                      'Counseling Process List'
                    : this.props.url.split('/')[1] === 'assigned-candidate' ?
                      'Assigned Candidates List'
                    :
                      'Candidates List'
                  }
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Candidates Detail</Breadcrumb.Item>
              <Breadcrumb.Item>
                {data.fullName}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          {/* Page Header */}
          <Col span={24}>
            <PageHeader className="site-page-header" title='Candidate Detail' />
          </Col>
          {/* Menu */}
          <Col span={7}>
            <Card style={{ border: 'none' }}>
              <Row gutter={[16, 24]}>
                <Col span={24}>
                  <Space direction="horizontal">
                    <Avatar size={100} src={data.profilePicUrl ? data.profilePicUrl : svg} />
                    <Space direction="vertical" size="small">
                      <Text style={{ color: '#4d4d4d', fontSize: 18 }} strong>{data.fullName}</Text>
                      <Text type="secondary">{data.candidateNumber}</Text>
                      {
                        data.enabled ? 
                          <Tag color="success">Active</Tag>
                        :
                          <Tag color="error">Inactive</Tag>
                      }
                    </Space>
                  </Space>
                </Col>
                <Col span={24}>
                  <Menu rowKey="education" id={data.id} email={data.email}/>
                </Col>
              </Row>
            </Card>
          </Col>
          {/* Content */}
          <Col span={17}>
            <Card 
              style={{ border: 'none' }}
              title={<Text strong>Education</Text>} 
              extra={<Button key="1" className="btn-save-primary" type="primary" icon={<PlusOutlined />} onClick={data.enabled ? () => this.showModal('add') : this.showConfirmActive}>Add</Button>} 
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  {
                    data.listEducation.length > 0 ?
                    <React.Fragment>
                      {
                        data.listEducation.map((item, i) => (
                          <React.Fragment key={i}>
                            <div style={{ marginBottom: 11, display: 'flex', justifyContent: 'space-between' }}>
                            <Text style={{ color: '#32ab6d', fontSize: 14 }}>
                                {
                                  item.startYear || item.endYear ?
                                    item.startYear && item.endYear ?
                                    `${item.startYear} - ${item.endYear}`

                                    : item.startYear && item.current ?
                                    `${item.startYear} - Present`
                                    : item.startYear || item.endYear
                                  : null
                                }
                              </Text>
                              <Space> 
                                <Tooltip title="Edit">
                                  <EditOutlined style={{ fontSize: 20, cursor: 'pointer', color: '#32ab6d' }} onClick={data.enabled ? () => this.showModal('edit', item) : this.showConfirmActive} />
                                </Tooltip>
                                <Tooltip title="Remove">
                                  <DeleteOutlined style={{ fontSize: 20, cursor: 'pointer', color: '#d8675a' }} onClick={data.enabled ? () => this.handleDelete(item.id) : this.showConfirmActive} />
                                </Tooltip>
                              </Space>
                            </div>
                            <Descriptions layout="vertical" size="small" column={2}>
                              <Descriptions.Item label="School / University">
                                {item.name ? item.name : 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Field of Study">
                                {item.fieldOfStudy ? item.fieldOfStudy : 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Education Level">
                                {item.educationLevelName ? item.educationLevelName : 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Score/Grade/GPA">
                                {item.gpa ? item.gpa : 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Website">
                                {item.website ? item.website : 'N/A'}
                              </Descriptions.Item>
                              <Descriptions.Item label="Activity and Organization Experiences">
                                {item.experience ? item.experience : 'N/A'}
                              </Descriptions.Item>
                            </Descriptions>
                            <Divider />
                          </React.Fragment>
                        ))
                      }
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <Empty description={<Text>No Data Education</Text>} />
                    </React.Fragment>
                  }
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Modal
          key="1"
          centered
          width={1000}
          destroyOnClose
          visible={visibleAdd}
          onCancel={() => this.onCancel('add')}
          title={<Text strong>Add Education</Text>}
          footer={[
            <React.Fragment key="1">
              <Button key="back" className="btn-save-primary" onClick={() => this.onCancel('add')}>Cancel</Button>
              <Button key="submit" className="btn-save-primary" type="primary" onClick={this.onSubmitAdd}>Save</Button>
            </React.Fragment>
          ]}
        >
          <AddEducation 
            {...this.props} 
            {...this.state}
            formRef={this.formRef} 
            isBinawan={isBinawan}
            onSubmitAdd={this.onSubmitAdd} 
            handleChecked={this.handleChecked}
            onChangeEndYear={this.onChangeEndYear}
            onChangeStartYear={this.onChangeStartYear}
            onFocusInstitution={this.onFocusInstitution}
            onFocusFieldOfStudy={this.onFocusFieldOfStudy}
            onSearchInstitution={this.onSearchInstitution}
            onChangeInstitution={this.onChangeInstitution}
            onSearchFieldOfStudy={this.onSearchFieldOfStudy}
            onChangeEducationLevel={this.onChangeEducationLevel}
          />
        </Modal>
        <Modal
          key="2"
          centered
          width={1000}
          destroyOnClose
          visible={visibleEdit}
          onCancel={() => this.onCancel('edit')}
          title={<Text strong>Edit Education</Text>}
          footer={[
            <React.Fragment key="1">
              <Button key="back" className="btn-save-primary" onClick={() => this.onCancel('edit')}>Cancel</Button>
              <Button key="submit" className="btn-save-primary" type="primary" onClick={this.onSubmitEdit}>Save</Button>
            </React.Fragment>
          ]}
        >
          <EditEducation 
            {...this.props} 
            {...this.state}
            formRef={this.formRef} 
            onSubmitAdd={this.onSubmitAdd} 
            handleChecked={this.handleChecked}
            onChangeEndYear={this.onChangeEndYear}
            onChangeStartYear={this.onChangeStartYear}
            onFocusInstitution={this.onFocusInstitution}
            onFocusFieldOfStudy={this.onFocusFieldOfStudy}
            onSearchInstitution={this.onSearchInstitution}
            onSearchFieldOfStudy={this.onSearchFieldOfStudy}
            onChangeEducationLevel={this.onChangeEducationLevel}
          />
        </Modal>
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    const { unmountGetDetail, unmountGetInstitution, unmounGetEducation, unmountGetFieldOfStudy } = this.props;
    unmountGetDetail()
    unmountGetInstitution()
    unmounGetEducation()
    unmountGetFieldOfStudy()
  }
}

const mapStateToProps = (state) => ({
  getDetailCandidate  : state.candidate.detail,
  getInstitution      : state.institutions.list,
  getEducation        : state.educationLevel.master,
  getFieldOfStudy     : state.fieldOfStudy.list,
})

const mapDispatchToProps = {
  actionAdd               : addEducation,
  actionUpdate            : updateEducation,
  actionDelete            : deleteEducation,
  actionGetDetail         : detailCandidate,
  actionGetInstitution    : listInstitutions,
  actionGetEducation      : masterEducationLevel,
  actionGetFieldOfStudy   : listFieldOfStudy,
  actionEnable            : enableCandidate,
  unmountGetDetail        : unmountDetailCandidate,
  unmountGetInstitution   : unmountListInstitutions,
  unmounGetEducation      : unmountMasterEducationLevel,
  unmountGetFieldOfStudy  : unmountListFieldOfStudy
}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateDetailEducation)
